import { InjectionToken } from '@angular/core';

/** Runtime VM emitted by `CartVoucherBlock` data sources. */
export type CartVoucherBlockViewModel = {
  isVisible: boolean;
};

export const CART_VOUCHER_BLOCK_LOADING_VM: CartVoucherBlockViewModel = {
  isVisible: false,
};

export interface CartVoucherBlockDataSource {
  readonly vm$: import('rxjs').Observable<CartVoucherBlockViewModel>;
}

export const CART_VOUCHER_BLOCK_DATA_SOURCE = new InjectionToken<CartVoucherBlockDataSource>(
  'CART_VOUCHER_BLOCK_DATA_SOURCE',
);
